import { useState } from "react";

export const usePagination = (initialPage = 1, limit = 6) => {
  const [page, setPage] = useState(initialPage);
  const resetPage = () => setPage(initialPage);
  return { page, setPage, limit, resetPage };
};
